var _g, _title;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelocationAssistanceServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "98.793 112.716 415.295 431.907",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "M 425.196 206.305 C 406.136 185.122 373.591 194.816 366.615 223.754 C 363.907 234.987 365.862 246.978 371.943 256.443 L 394.833 292.058 C 397.58 296.334 403.296 296.334 406.043 292.058 L 428.933 256.443 C 438.928 240.976 437.345 219.733 425.196 206.305 Z M 400.438 246.582 C 391.602 246.582 386.079 235.951 390.497 227.445 C 394.916 218.94 405.961 218.94 410.379 227.445 C 411.387 229.385 411.917 231.585 411.917 233.824 C 411.917 240.87 406.778 246.581 400.438 246.582 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    d: "M 401.224 309.313 C 394.71 309.313 389.936 313.959 389.937 321.318 L 388.77 389.347 C 388.77 425.606 354.029 448.268 326.236 430.139 C 313.337 421.725 305.391 406.175 305.391 389.347 L 305.391 268.494 C 305.443 211.72 251.079 176.173 207.535 204.509 C 187.285 217.687 174.814 242.09 174.838 268.494 L 174.838 331.32 C 174.86 341.578 184.702 347.962 192.553 342.812 C 196.179 340.433 198.415 336.058 198.425 331.32 L 198.425 268.494 C 198.384 232.234 233.1 209.522 260.913 227.612 C 273.854 236.029 281.823 251.623 281.804 268.494 L 281.804 389.347 C 281.81 446.121 336.211 481.597 379.725 453.204 C 399.915 440.03 412.354 415.689 412.356 389.347 L 412.639 321.159 C 412.64 313.799 407.737 309.313 401.224 309.313 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    d: "M 185.471 358.061 C 169.03 358.061 158.755 376.434 166.975 391.133 C 175.196 405.831 195.747 405.831 203.967 391.133 C 205.842 387.781 206.828 383.979 206.828 380.109 C 206.816 367.937 197.261 358.074 185.471 358.061 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelocationAssistanceServices);
export default __webpack_public_path__ + "static/media/relocation-assistance-services.37f97018a1a55364995fc2320ca3fb4a.svg";
export { ForwardRef as ReactComponent };